module.exports = __webpack_public_path__ + "img/mobile scanner stand12.ce491556.jpg";